import { createContext, useContext } from 'react';
import { CancelSurvey, EnrollmentFlowType } from '../types';
import { usePaymentsEnrollmentUtilities } from '../hooks/usePaymentsEnrollmentUtilities';
import { jsx as _jsx } from "react/jsx-runtime";
export const initialPaymentsEnrollmentUtilitiesContextValues = {
  currentEnrollmentFlow: undefined,
  enrollmentFlowLocation: null,
  setCurrentEnrollmentFlow: () => {},
  openEnrollmentFlow: () => {},
  handleIframeReady: () => {},
  handleIframeOnMessage: () => {},
  isLoading: false,
  handlePaymentsEnrollmentClose: () => {},
  showNativeSuccessModal: false,
  setShowNativeSuccessModal: () => {},
  showNativeFallbackModal: false,
  setShowNativeFallbackModal: () => {},
  showEmbeddedOnboarding: false,
  setShowEmbeddedOnboarding: () => {},
  showCancelModal: false,
  showOAuthOnboardingSuccessModal: false,
  handleCloseCancelModal: () => {},
  cancelSurveyType: CancelSurvey.NATIVE,
  setCancelSurveyType: () => {},
  setShowOAuthOnboardingSuccessModal: () => {},
  businessTypeDetails: {
    businessType: null,
    businessStructure: null
  },
  sourceApp: '',
  location: ''
};
const PaymentsEnrollmentUtilitiesContext = /*#__PURE__*/createContext(initialPaymentsEnrollmentUtilitiesContextValues);
export const PaymentsEnrollmentUtilitiesProvider = ({
  children,
  enrollmentType = EnrollmentFlowType.processorPicker,
  sourceApp,
  location,
  onPaymentsEnrollmentSuccess
}) => {
  const paymentsEnrollmentUtilities = usePaymentsEnrollmentUtilities(enrollmentType, sourceApp, location, onPaymentsEnrollmentSuccess);
  return /*#__PURE__*/_jsx(PaymentsEnrollmentUtilitiesContext.Provider, {
    value: paymentsEnrollmentUtilities,
    children: children
  });
};
export const usePaymentsEnrollmentUtilitiesContext = () => useContext(PaymentsEnrollmentUtilitiesContext);
export default PaymentsEnrollmentUtilitiesContext;